import {
	SupervisorAgentsFilterActions,
	useSupervisorAgentsFilterStore,
} from "@/common/stores/nonpersistingStores/supervisorAgentsFilter";
import { useAuth } from "@/hooks/authentication";
import { useEffect } from "react";
import {
	AppCacheActions,
	AppCacheState,
	CacheKey,
	useAppCacheStore,
} from "@/common/stores/persistingStores/app";
import { getInitialSupervisorFilterData } from "@/common/helpers/supervisorHelper";

export const useSupervisorAgentsFilterManager = () => {
	const authContext = useAuth();
	const supervisorAgentsFilterActions = useSupervisorAgentsFilterStore(
		(actions: SupervisorAgentsFilterActions) => actions
	);

	const appStoreCache = useAppCacheStore((state: AppCacheState) => state.cache);
	const appStoreActions = useAppCacheStore((state: AppCacheActions) => state);

	useEffect(() => {
		if (!authContext.isLogged) {
			return;
		}

		const supervisorAgentsData =
			appStoreCache[CacheKey.SupervisorAgentsFilterData];

		if (supervisorAgentsData) {
			supervisorAgentsFilterActions.setFilterData(supervisorAgentsData);
		} else {
			appStoreActions.setCache(
				CacheKey.SupervisorAgentsFilterData,
				getInitialSupervisorFilterData()
			);
		}
	}, [authContext.isLogged]);
};
